import * as React from 'react';

export const MinusIcon = ({ ...props }: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="10" height="2" viewBox="0 0 10 2" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 1.99883V0.0012207H10V1.99883H0Z" fill={props.fill || '#F4F5F6'} />
    </svg>
  );
};
